import styled from "styled-components";
import Select from "react-select";
import Switch from "@mui/material/Switch";
import React from "react";
import {useForm, useController} from "react-hook-form";
import {useQuery} from "react-query";
import {
    allApplicationUserRole,
    BlueprintsCategories,
    cloudTypes, subPillars,
} from "../../../../utils/const/query-key";
import apiService from "../../../../api/apiService";
import {alpha, FormControlLabel} from "@mui/material";
import {styled as st} from "@mui/material/styles";
import {pink} from "@mui/material/colors";
import {useNavigate} from "react-router-dom";


const GreenSwitch = st(Switch)(({theme}) => ({
    '& .MuiSwitch-switchBase.Mui-checked': {
        color: pink[600],
        '&:hover': {
            backgroundColor: alpha(pink[600], theme.palette.action.hoverOpacity),
        },
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
        backgroundColor: pink[600],
    },
}));

const FormWrapper = styled.div`
    padding: 30px 50px;
    background: var(--color-createenv-wrapper-bg-white) 0% 0% no-repeat padding-box;
    box-shadow: 0px 10px 20px var(--color-createenv-form-wrapper-box-shadow);   
    opacity: 1;
`

const Title = styled.div`
 text-align: left;
 margin: 25px 0;
 font: normal normal normal 24px/31px DIN Pro;
 color: var(--color-text-general);
 text-transform: capitalize;
 opacity: 1;
`;

const RightContainer = styled.div`
 width: 40%;
 height: 650px;
 opacity: 1;
`;

const RowContainer = styled.div`
 display:flex;
 justify-content: space-around
`;
const LeftContainer = styled.div`
 width: 60%;
 border-right: 1px solid var(--color-border-general);
 height: 650px;
 opacity: 1;
`;

const FooterContainer = styled.div`
 border-right: 1px solid var(--color-border-general);
 opacity: 1;
 display: flex;
 margin:20px;
 justify-content: flex-end
`;


const Wrapper = styled.div`
 display:flex;
 opacity: 1;
`;
const InputContainer = styled.div`
  margin: 10px;
  width: -webkit-fill-available;
`;
const Input = styled.input`
  width: inherit;
  height: 36px;
  background: var(--color-workspace-bg-page-area) 0% 0% no-repeat padding-box;
  margin-bottom: 15px;
  border: 1px solid var(--color-table-border-pageinput);
  border-radius: 3px;
  opacity: 1;
  font-size: 14px;


  &:focus-visible {
    outline-color: var(--color-brand-pink-primary);
  }
  /* Hide the increment and decrement arrows in input type=number */
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  
`;
const Button = styled.button`

  width: 75px;
  height: 36px;
  border: 1px solid var(--color-createenv-form-btn-border);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    background: var(--color-table-even);
    color: var(--color-brand-pink-primary);
  }

  &.submit {
    background: var(--color-brand-pink-primary);
    color: var(--color-workspace-bg-page-area);
    border-radius: 2px;
    margin-right: 17px;


  }
`;
const TextArea = styled.textarea`
  max-width: 100%;
  width: 100%;
  height: 160px;
  max-height:250px;
  background: var(--color-workspace-bg-page-area) 0% 0% no-repeat padding-box;
  margin-bottom: 15px;
  border: 1px solid var(--color-table-border-pageinput);
  border-radius: 3px;
  opacity: 1;
  
  
  &:focus-visible {
    outline-color: var(--color-table-filter-hover);
  }
 
`;
export const Description = styled.div`
  font-size: 14px;
  color: var(--color-form-font-description);
  margin-bottom: 5px;
`;


export const customTheme = (theme) => {
    return {
        ...theme,
        colors: {
            ...theme.colors,
            primary: "#ec407a",
            primary25: "#FDEBF1",
            dangerLight: "#FDEBF1",
            neutral10: "#FDEBF1",
        },
        width: 465
    };
};

const blueprintInitial = {
    name: '',
    cloudTypeId: '',
    categoryId: '',
    description: '',
    userGuideLink: '',
    videoLink: '',
    duration: '',
    message: '',
    staticLink: '',
    userRole: '',
    active: true,
    subPillar: '',
    isDeleted: false,
    priority:10,
}
const PriorityOptionRange=[...new Array(10)]
    .map((each, index) => {
        const value = index+1 ;
        return ({
            label: value,
            value,
        })
    })


const BlueprintForm = ({title, onSubmit, blueprint = blueprintInitial}) => {

    const {data: cloudTypeData} = useQuery(cloudTypes, () => apiService.getCloudTypes(), {initialData: {}});

    //filter the response by showing only "is valid" category
    const {data: categoryData} = useQuery(BlueprintsCategories, () => apiService.getBlueprintCategoryData(), {initialData: {},
        select: (data) => Object.keys(data).filter(key => data[key].isvalid).reduce((obj, key) => {
            obj[data[key].id] = data[key].name;
            return obj;
        }, {}),
    });

    const {data: userRoleData} = useQuery(allApplicationUserRole, () => apiService.getAllApplicationUserRoles(), {initialData: []});
    const {data: subPillarData} = useQuery(subPillars, () => apiService.getSubPillars(), {initialData: []});
    const navigate = useNavigate();
    const goBack = () => {
        navigate("/admin");
    };
    //control is for drop down option, watch is for on/off button
    const {register, control, handleSubmit, watch} = useForm({defaultValues: blueprint});
    const {field: fieldCloudTypeId} = useController({name: 'cloudTypeId', control})
    const {field: fieldCategory} = useController({name: 'categoryId', control})
    const {field: fieldUserRole} = useController({name: 'userRole', control})
    const {field: fieldSubPillar} = useController({name: 'subPillar', control})
    const {field: fieldPriority} = useController({name: 'priority', control})
    const checkedActive = watch('active');
    const checkedIsDeleted = watch('isDeleted');


    const mySubmitHandler = (formValues) => {
        onSubmit(formValues)

    }
    const allowOnlyNumbers=(event)=>{
        if (!((event.keyCode >= 48 && event.keyCode <= 57) || // 0-9
                (event.keyCode >= 96 && event.keyCode <= 105) || // numpad 0-9
                event.keyCode === 8 || // backspace
                event.keyCode === 46 // delete
             )) {
            event.preventDefault();
        }
    }
    const handelSelectChange = (id, option) => {
        switch (id) {
            case "cloudTypeId":
                fieldCloudTypeId.onChange(option.value)
                break;
            case "categoryId":
                fieldCategory.onChange(option.value)
                break;
            case "userRole":
                fieldUserRole.onChange(option.value)
                break;
            case "subPillar":
                fieldSubPillar.onChange(option.value)
                break;
            case "priority":
                fieldPriority.onChange(option.value)
                break;
            default:
                break;
        }
    }

    // in edit - should choose the blueprint details option by default
    const useMatchingOptionByValue = (dropdownOptions, field,text) => {
        if(text==="blueprint.userRole"){
          return dropdownOptions.find((option) => (option.value === field.value.id))
        }
        return dropdownOptions.find((option) => (option.value === field.value))
    }


    return (
        <FormWrapper className={"blueprint-form"}>
            <Title>{title}</Title>
            <form onSubmit={handleSubmit(mySubmitHandler)} autoComplete={"off"}>
                <Wrapper className={"wrapper"}>
                    <LeftContainer className={"left-container"}>
                        <RowContainer>
                            <InputContainer>
                                <Description>
                                    Cloud Type
                                </Description>
                                <Select
                                    {...register('cloudTypeId', {required: true})}
                                    onChange={(option) => {
                                        handelSelectChange("cloudTypeId", option)
                                    }}
                                    theme={customTheme}
                                    options={Object.entries(cloudTypeData).map(([key, value]) => ({
                                        value: parseInt(key),
                                        label: value
                                    }))}
                                    placeholder={"Select"}
                                    value={useMatchingOptionByValue(Object.entries(cloudTypeData).map(([key, value]) => ({
                                        value: parseInt(key),
                                        label: value
                                    })), fieldCloudTypeId)}>
                                </Select>
                            </InputContainer>
                            <InputContainer>
                                <Description>
                                    Pillar
                                </Description>
                                <Select
                                    {...register('categoryId', {required: true})}
                                    onChange={(option) => {
                                        handelSelectChange("categoryId", option)
                                    }}
                                    theme={customTheme}
                                    options={Object.entries(categoryData).map(([key, value]) => ({
                                        value: parseInt(key),
                                        label: value
                                    }))}
                                    placeholder={"Select"}
                                    value={useMatchingOptionByValue(Object.entries(categoryData).map(([key, value]) => ({
                                        value: parseInt(key),
                                        label: value
                                    })), fieldCategory)}/>
                            </InputContainer>
                        </RowContainer>
                        <RowContainer>
                            <InputContainer>
                                <Description>
                                    Blueprint Name
                                </Description>
                                <Input {...register("name", {required: true})} placeholder="Type Blueprint Name"/>
                            </InputContainer>

                        </RowContainer>
                        <RowContainer>
                            <InputContainer>
                                <Description>
                                    Blueprint Description
                                </Description>
                                <TextArea  {...register('description', {required: true})}
                                           placeholder="Blueprint Description"/>
                            </InputContainer>
                        </RowContainer>
                        <RowContainer>
                            <InputContainer>
                                <Description>
                                    User Guide Link
                                </Description>
                                <Input  {...register('userGuideLink',{required: true})} placeholder="Type User Guide Link"/>
                            </InputContainer>
                        </RowContainer>
                        <RowContainer>
                            <InputContainer>
                                <Description>
                                    Video Link
                                </Description>
                                <Input {...register('videoLink')} placeholder="Type Video Link"/>
                            </InputContainer>
                        </RowContainer>
                        <RowContainer>
                            <InputContainer>
                                <Description>
                                    Static Link
                                </Description>
                                <Input  {...register('staticLink')} placeholder="Type Static Link"/>
                            </InputContainer>
                        </RowContainer>
                    </LeftContainer>
                    <RightContainer className={"right-container"}>
                        <RowContainer>
                            <InputContainer>
                                <Description>
                                    Duration (Hrs)
                                </Description>
                                <Input {...register('duration', {required: true,})} placeholder={"0"} type="number" onKeyDown={allowOnlyNumbers}/>
                            </InputContainer>
                        </RowContainer>
                        <RowContainer>
                            <InputContainer>
                                <Description>
                                    Blueprint ID
                                </Description>
                                <Input {...register('cloudBlueprintId')} placeholder="Type Blueprint ID"/>
                            </InputContainer>
                        </RowContainer>
                        <RowContainer>
                            <InputContainer>
                                <Description>
                                    Sub Pillar
                                </Description>
                                <Select
                                    {...register('subPillar', {required: true})}
                                    onChange={(option) => {
                                        handelSelectChange("subPillar", option)
                                    }}
                                    theme={customTheme}
                                    options={subPillarData.map(({name}) => ({value:name, label: name}))}
                                    placeholder={"Select"}
                                    value={useMatchingOptionByValue(subPillarData.map(({name}) => ({value:name, label: name})), fieldSubPillar)}/>
                            </InputContainer>
                        </RowContainer>
                        <RowContainer>
                            <InputContainer>
                                <Description>
                                    Success Message
                                </Description>
                                <TextArea  {...register('message')}
                                        placeholder="Type Success Message"/>
                            </InputContainer>
                        </RowContainer>
                        <RowContainer>
                            <InputContainer>
                                <Description>
                                    User Role
                                </Description>
                                <Select
                                    {...register('userRole', {required: true})}
                                    onChange={(option) => {
                                        handelSelectChange("userRole", option)
                                    }}
                                    theme={customTheme}
                                    options={(userRoleData).map(({id, name}) => ({value: {id, name}, label: name}))}
                                    placeholder={"Select"}
                                    value={useMatchingOptionByValue((userRoleData).map(({id, name}) => ({
                                        value: id,
                                        label: name
                                    })), fieldUserRole, "blueprint.userRole")}/>
                            </InputContainer>
                        </RowContainer>
                        <RowContainer>
                            <InputContainer>
                                <Description>
                                    Active
                                </Description>
                                <FormControlLabel {...register('active')} control={<GreenSwitch/>} id={"switcher"}
                                                  checked={checkedActive}/>
                            </InputContainer>
                            <InputContainer>
                                <Description>
                                    Is Deleted
                                </Description>
                                <FormControlLabel {...register('isDeleted')} control={<GreenSwitch/>} id={"switcher"}
                                                  checked={checkedIsDeleted}/>
                            </InputContainer>
                            <InputContainer>
                                <Description>
                                    Priority
                                </Description>
                                <Select
                                    {...register('priority', {required: true})}
                                    onChange={(option) => {
                                        handelSelectChange("priority", option)
                                    }}
                                    theme={customTheme}
                                    options={PriorityOptionRange}
                                    placeholder={"Select"}
                                    value={PriorityOptionRange.find((option) => (option.value === fieldPriority.value))}
                                />
                            </InputContainer>
                        </RowContainer>
                    </RightContainer>
                </Wrapper>
                <FooterContainer>
                    <Button type={"submit"}>
                        Submit
                    </Button>
                    <Button onClick={goBack}>
                        Cancel
                    </Button>
                </FooterContainer>
            </form>
        </FormWrapper>
    )
}
export default BlueprintForm;